function push(props, destination) {
  props.history.push(destination);
}

function replace(props, destination) {
  props.history.replace(destination);
}

const NavigationSupport = {
  push,
  replace,
};

export default NavigationSupport;
